/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CommunicationKindEnum = {
    Manual: 'MANUAL',
    AppointmentConfirmation: 'APPOINTMENT_CONFIRMATION',
    AppointmentReminder: 'APPOINTMENT_REMINDER',
    AppointmentCancellation: 'APPOINTMENT_CANCELLATION',
    Crm: 'CRM',
    Helpdesk: 'HELPDESK',
    VerificationCode: 'VERIFICATION_CODE',
    FormReminder: 'FORM_REMINDER'
} as const;
export type CommunicationKindEnum = typeof CommunicationKindEnum[keyof typeof CommunicationKindEnum];

